import {
  GET_USERS,
  EDIT_USER,
  DELETE_USER,
  GET_USER_BY_ID,
  SET_USER_TO_NULL,
} from "./types";

const initialState = {
  users: [],
  userToEdit: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user.key !== action.payload),
      };
    case GET_USER_BY_ID:
      return {
        ...state,
        userToEdit: action.payload,
      };
    case SET_USER_TO_NULL:
      return {
        ...state,
        userToEdit: null,
      };

    default:
      return state;
  }
};
